<script setup>
const content =
  'De schaal Relationeel geeft aan in hoeverre u rekening houdt met anderen en gemakkelijk relaties onderhoudt met anderen. <br> Iemand die hoog scoort op deze schaal voelt anderen goed aan en durft open te zijn over zijn/haar gevoelens en ideeën. Hierdoor bouwt hij/zij gemakkelijk wederzijds vertrouwen op. <br> Laagscoorders varen liever hun eigen koers en laten zich niet al te sterk beïnvloeden door de meningen en gevoelens van anderen.'
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
